import AsyncStorage from '@react-native-async-storage/async-storage';
import React from 'react';
import { AnalyticsService } from '../../constants/Analytics';
import useMounted from '../../hooks/useMounted';
import http from '../../utils/http';

const analytics = new AnalyticsService()

const PhoneRep = () => {
    const isMounted = useMounted();
    const [loading, setLoading] = React.useState(false)
    const [phoneRep, setPhoneRep] = React.useState(null)

    React.useEffect(() => {
        setLoading(true)
        AsyncStorage.getItem('PHONE_REP')
            .then(value => {
                isMounted.current && setPhoneRep(value)
            }, error => {
                isMounted.current && setPhoneRep(null)
                analytics.logError(error)
            })
            .catch(error => {
                isMounted.current && setPhoneRep(null)
                analytics.logError(error)
            })
            .finally(() => {
                isMounted.current && setLoading(false)
            })

        return () => null
    }, [])

    return [phoneRep, loading]
}

export default PhoneRep